module.exports = __webpack_public_path__ + "imgascvts/logo_ass02.2e883279.png";